import { createContext } from 'react';
import {
  TransactionCompsCell,
  TransactionCompsTableData,
  TransactionQueryResponse,
  WritableCompGroupTransaction,
} from 'pages/ValuationsAllocation/approaches/TransactionComps/types';

type SaveCompGroups = (
  transactionsFromCG: WritableCompGroupTransaction[],
  useLatestVersion: boolean,
  transactionsToDelete: number[],
  compGroupToDelete: number
) => void;
type DeleteCompGroup = (compGroupToDelete: number | string) => void;

type CellOptionsFunction = <T extends TransactionCompsCell>(
  cell: T,
  expr: string
) => Promise<TransactionQueryResponse | undefined>;

type CellOptions =
  | boolean
  | {
      [key: string]: number | undefined;
    }
  | CellOptionsFunction;

export interface CompGroupContextType {
  saveCompGroups: SaveCompGroups;
  deleteCompGroup: DeleteCompGroup;
  tableData: TransactionCompsTableData;
  approachType: string;
  cellOptions: CellOptions;
}

const CompGroupContext = createContext<CompGroupContextType>({} as CompGroupContextType);

export default CompGroupContext;
